import * as React from 'react';
import { Redirect } from 'react-router';
import { CacheSwitch } from 'react-router-cache-route';

import { FeatureName, useFeature } from '../../flags';
import { WizardMRF } from '../../pages/Wizard/ModelReleaseForm/WizardMRF';
import { WizardPayout as WizardPayoutV1 } from '../../pages/Wizard/Payout/WizardPayout';
import { WizardPayout as WizardPayoutV2 } from '../../pages/Wizard/PayoutV2/WizardPayout';
import { WizardProfile } from '../../pages/Wizard/Profile/WizardProfile';
import { WizardVerification } from '../../pages/Wizard/Verification/WizardVerification';
import { ProtectedRoute } from '../../utils/ProtectedRoute';
import { routes } from '../routesConfig';

const WizardRouter: React.FC = () => {
  const isFeaturingWizardPayoutV2 = useFeature(FeatureName.wizardPayoutV2);

  return (
    <CacheSwitch>
      <ProtectedRoute
        routeConfig={routes.wizardVerification}
        path={routes.wizardVerification.path}
        component={WizardVerification}
      />
      <ProtectedRoute
        routeConfig={routes.wizardProfile}
        path={routes.wizardProfile.path}
        component={WizardProfile}
      />
      <ProtectedRoute
        routeConfig={routes.wizardMRF}
        path={routes.wizardMRF.path}
        component={WizardMRF}
      />
      <ProtectedRoute
        routeConfig={routes.wizardPayout}
        path={routes.wizardPayout.path}
        component={WizardPayoutV1}
      />
      {isFeaturingWizardPayoutV2 && (
        <ProtectedRoute
          routeConfig={routes.wizardPayoutV2}
          path={routes.wizardPayoutV2.path}
          component={WizardPayoutV2}
        />
      )}
      <Redirect to={routes.home.path} />
    </CacheSwitch>
  );
};

export default WizardRouter;
